import {HIDE_NOTIFICATION, SHOW_NOTIFICATION} from "../actions/notification";

const INITIAL_STATE = {
  notify: false,
  message: "",
  type: "warning"
};

export const notificationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case HIDE_NOTIFICATION:
      return { ...state, notify: false };

    case SHOW_NOTIFICATION:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/notification.js